import(/* webpackMode: "eager" */ "/vercel/path0/website/app/docs/page.tsx");
